/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topic_Drag_CancelInputs */



/**
* | output |
* | --- |
* | "Move of topic cancelled." |
*
* @param {Settings_Template_Topic_Drag_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_drag_cancel = /** @type {((inputs?: Settings_Template_Topic_Drag_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Drag_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verplaatsen van onderwerp geannuleerd.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacement du sujet annulé.")
	return /** @type {LocalizedString} */ ("Move of topic cancelled.")
});